import {
  Component,
  Input,
  booleanAttribute,
  ChangeDetectionStrategy,
} from '@angular/core';

import { CommonModule } from '@angular/common';
import { TranslatePipe } from '@app/pipes/translate.pipe';
import { RouterLink } from '@angular/router';

@Component({
  imports: [CommonModule, TranslatePipe, RouterLink],
  selector: 'app-breadcrumb-list',
  templateUrl: './breadcrumb-list.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./breadcrumb-list.component.scss'],
})
export class BreadcrumbListComponent {
  @Input() partsOfUrl!: { name: string; url: string }[];
  @Input() noPaddingLeftAndTopMobile: boolean = false;
  @Input() transparent: boolean = false;
  @Input({ transform: booleanAttribute }) imageOverlay: boolean = false;
  @Input() standard_max_width: boolean = false;
  @Input() dark_backdrop: boolean = false;
  @Input() vertical: boolean = false;

  capitalizeFirstLetter(sentence: string) {
    if (!sentence) return '';
    return sentence.charAt(0).toUpperCase() + sentence.slice(1);
  }
}
